<template>
  <b-modal
    ref="plu-config-modal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
    size="sm"
    @hide="closeModal"
  >
    <h6>Add Weighing Scale (PLU Code)</h6>
    <b-row class="mb-3 mt-4">
      <b-form-group
        id="delimiter"
        label="Delimiter Symbol"
        label-for="delimiter"
        class="col-md-12"
      >
        <b-form-input
          type="text"
          v-model="delimiter"
          autocomplete="off"
          placeholder="Enter delimiter symbol"
          maxLength="1"
          @keydown="checkVal"
          id="input-delimiter-symbol"
        ></b-form-input>
      </b-form-group>

      <!-- <b-form-group
        label="Weighing Unit"
        label-for="weighing_unit"
        class="col-md-12 mt-3 mb-4"
      >
        <b-form-radio-group
          id="weighing-unit"
          v-model="weighing_unit"
          :options="options"
          name="radio-options"
        ></b-form-radio-group>
      </b-form-group> -->

      <b-form-group
        id="select-format"
        label-for="Select Format"
        label="Select Format"
        class="col-md-12 mt-1"
      >
        <b-form-select
          v-model="format"
          style="cursor: pointer"
          class="fs-12"
          id="select-forrmat"
        >
          <option value="" selected disabled>
            Select Format
          </option>
          <option
            v-for="sort in formatList"
            :value="sort.value"
            v-text="sort.text"
            :key="sort.value"
            :id="sort.text"
          ></option>
        </b-form-select>
        <!-- <b-form-input id="custCity" v-model="form.custCity" type="text" placeholder="City"></b-form-input> -->
      </b-form-group>

      <b-form-group
        id="preview"
        label="Preview"
        label-for="preview"
        class="col-md-12 mt-1"
        v-if="this.delimiter != '' && format != ''"
      >
        <b-form-input
          type="text"
          class
          v-model="preview"
          autocomplete="off"
          placeholder="Preview"
          readonly
          id="preview"
        ></b-form-input>
      </b-form-group>
    </b-row>
    <div class="mt-5 d-flex">
      <b-button @click="closeModal" block id="cancel-config" class="mr-1"
        >Cancel</b-button
      >
      <b-button
        variant="primary"
        block
        class="ml-1"
        @click="saveConfig"
        id="save-config"
        :disabled="delimiter == '' || format == ''"
        >Save</b-button
      >
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import * as helper from "../helper";

export default {
  name: "plu-config-modal",
  props: ["open"],
  data() {
    return {
      // weighing_unit: "kg",
      options: [
        { text: "Kilograms", value: "kg" },
        { text: "Grams", value: "gm" },
      ],
      format: "",
      delimiter: "",
      formatList: [
        { text: "Weight-Delimiter-Barcode (Prefix)", value: "prefix" },
        { text: "Barcode-Delimiter-Weight (Suffix)", value: "suffix" },
      ],
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    preview() {
      return this.format == "suffix"
        ? "12345678" + this.delimiter + "400"
        : "400" + this.delimiter + "12345678";
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.delimiter = this.state.system.plu_data.delimiter;
        this.format = this.state.system.plu_data.format;
        // this.weighing_unit =
        //   this.state.system.plu_data.unit == ""
        //     ? "kg"
        //     : this.state.system.plu_data.unit;
        this.$refs["plu-config-modal"].show();
      } else {
        this.$refs["plu-config-modal"].hide();
      }
    },
  },
  methods: {
    checkVal(e) {
      if (
        helper.checkSpecialCharacter(e.key) ||
        e.key == "Backspace" ||
        e.key == "Delete" ||
        e.key == "ArrowLeft" ||
        e.key == "ArrowRight"
      )
        return;
      else return e.preventDefault();
    },
    closeModal() {
      this.$emit("plu-config-close");
    },
    saveConfig() {
      let data = {
        delimiter: this.delimiter,
        // unit: this.weighing_unit,
        format: this.format,
      };
      this.$store.commit("system/saveWeightPort", "");
      this.$store.commit("system/setPluData", data);
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="scss">
.theme-light input:read-only {
  background-color: transparent !important;
  border: 1px #c0c0c0 solid !important;
  color: #000;
}
.theme-dark h6 {
  color: #fff;
}
h6 {
  font-weight: normal;
}
</style>
